// src/data/gyms/ExtremeForce.js
export const ExtremeForce = {
  id: "extremeforce",
  name: "Extreme Force All Stars",
  color: "#7F1D1D", // Deep Red
  lightColor: "#FEF2F2",
  logo: "💥",

  teams: [
    { id: "intensity", name: "Intensity", level: "L1.1 Youth - PREP" },
    { id: "phoenix", name: "Phoenix", level: "L1 Junior - D2" },
    { id: "reign", name: "Reign", level: "L3 Senior - D2" },
    { id: "storm", name: "Storm", level: "L2 Senior - D2" },
    { id: "explosion", name: "Explosion", level: "L1 Youth - D2 - Small" },
  ],

  schedule: [
    // ================= SATURDAY (Dec 13) =================
    {
      day: "Saturday",
      time: "9:55 AM",
      teamId: "intensity",
      meet: "9:19 AM",
      panel: "Hall B",
    },
    {
      day: "Saturday",
      time: "11:56 AM",
      teamId: "storm",
      meet: "11:20 AM",
      panel: "Hall B",
    },
    {
      day: "Saturday",
      time: "1:51 PM",
      teamId: "reign",
      meet: "1:15 PM",
      panel: "Hall A",
    },
    {
      day: "Saturday",
      time: "2:40 PM",
      teamId: "phoenix",
      meet: "2:04 PM",
      panel: "Hall A",
    },
    {
      day: "Saturday",
      time: "3:40 PM",
      teamId: "explosion",
      meet: "3:04 PM",
      panel: "Hall B",
    },

    // ================= SUNDAY (Dec 14) =================
    // Storm (Row 157)
    {
      day: "Sunday",
      time: "9:52 AM",
      teamId: "storm",
      meet: "9:16 AM",
      panel: "Hall B",
    },

    // Reign (Row 175)
    {
      day: "Sunday",
      time: "10:59 AM",
      teamId: "reign",
      meet: "10:23 AM",
      panel: "Hall A",
    },

    // Phoenix (Row 193 - Added this one!)
    {
      day: "Sunday",
      time: "12:28 PM",
      teamId: "phoenix",
      meet: "11:52 AM",
      panel: "Hall A",
    },

    // Explosion (Row 207)
    {
      day: "Sunday",
      time: "2:07 PM",
      teamId: "explosion",
      meet: "1:31 PM",
      panel: "Hall B",
    },
    // Note: Intensity is Prep and only competes Saturday.
  ],
};
